import {
  validateUserCategory,
  validateUserCommunity,
  validateUserSocialLink,
} from "./validators";
import CategoryField from "components/onboarding/create/CategoryField";
import CommunitySizeField from "components/onboarding/create/CommunitySizeField";
import SocialLinkField from "components/onboarding/create/SocialLinkField";

export const communityFields = [
  {
    name: "user_social_link",
    type: "text",
    required: true,
    label: "Share your social media link",
    placeholder: "Instagram, Telegram, Twitter...",
    validator: validateUserSocialLink,
    formatValue: (val) => val,
    component: SocialLinkField,
  },
  // {
  //   name: "user_community_size",
  //   type: "category",
  //   required: true,
  //   label: "What is the size of your paid community?",
  //   validator: validateUserCommunity,
  //   formatValue: (val) => val,
  //   component: CommunitySizeField,
  // },
  {
    name: "user_category",
    type: "category",
    required: true,
    label: "Select a category of your community",
    validator: validateUserCategory,
    formatValue: (val) => val,
    component: CategoryField,
  },
];
